import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';

export interface PillOption<T extends string | null> {
  key: string;
  label: string;
  value: T;
}

interface Props<T extends string | null> {
  label: string;
  ariaLabel?: string;
  options: Array<PillOption<T>>;
  value: T;
  onChange: (next: T) => void;
}

export default function FilterPillRow<T extends string | null>({
  label,
  ariaLabel,
  options,
  value,
  onChange,
}: Props<T>) {
  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: 'grey.100',
        borderRadius: 2,
        px: 2,
        py: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }} aria-label={ariaLabel ?? label}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', alignSelf: 'center', mr: 1 }}>
          {label}
        </Typography>
        {options.map((opt) => (
          <Button
            key={opt.key}
            size="small"
            variant={value === opt.value ? 'contained' : 'outlined'}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
}
